import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Search, Sparkles, User, Menu, X, Bookmark, Bell, Crown, TrendingUp } from "lucide-react";
import { useMember } from "../context/MemberContext";
import { useLang } from "../context/LangContext";

const MobileBottomNav = ({ onMenuOpen, onSearchOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { member } = useMember();
  const { t } = useLang();
  const [ripple, setRipple] = useState(null);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const handleClick = (path, action, e) => {
    // Ripple effect
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    setRipple({ x, y, key: Date.now() });
    setTimeout(() => setRipple(null), 500);

    if (action) {
      action();
    } else if (path) {
      navigate(path);
    }
  };

  const navItems = [
    { 
      icon: Home, 
      label: "Ana Sayfa", 
      path: "/",
      activeColor: "text-amber-500"
    },
    { 
      icon: Search, 
      label: "Ara", 
      action: onSearchOpen,
      activeColor: "text-blue-400"
    },
    { 
      icon: Sparkles, 
      label: "AI", 
      path: "/ai-asistan",
      activeColor: "text-blue-400",
      highlight: true
    },
    { 
      icon: member ? (member.role === "premium" ? Crown : User) : User, 
      label: member ? "Profil" : "Giriş", 
      path: member ? "/profil" : "/uye",
      activeColor: member?.role === "premium" ? "text-amber-500" : "text-emerald-400"
    },
    { 
      icon: Menu, 
      label: "Menü", 
      action: onMenuOpen,
      activeColor: "text-zinc-300"
    },
  ];

  return (
    <nav 
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0b]/95 backdrop-blur-xl border-t border-zinc-800/50 safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-1">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const active = item.path && isActive(item.path);
          
          return (
            <button
              key={index}
              onClick={(e) => handleClick(item.path, item.action, e)}
              className={`relative flex flex-col items-center justify-center flex-1 h-full transition-all duration-200 ${
                active ? item.activeColor : "text-zinc-500"
              } ${item.highlight ? "scale-110" : ""}`}
              data-testid={`mobile-nav-${index}`}
            >
              {/* Highlight ring for AI button */}
              {item.highlight && (
                <div className="absolute -top-1 w-12 h-12 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 animate-pulse" />
              )}
              
              <div className={`relative p-1.5 rounded-xl transition-all duration-200 ${
                active ? "bg-white/5" : ""
              }`}>
                <Icon className={`w-5 h-5 ${item.highlight ? "text-blue-400" : ""}`} />
                
                {/* Active indicator dot */}
                {active && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-current" />
                )}
              </div>
              
              <span className={`text-[10px] mt-0.5 font-medium transition-all duration-200 ${
                active ? "opacity-100" : "opacity-70"
              }`}>
                {item.label}
              </span>

              {/* Ripple effect container */}
              {ripple && (
                <span 
                  className="absolute w-8 h-8 bg-white/10 rounded-full animate-ripple pointer-events-none"
                  style={{ left: ripple.x, top: ripple.y }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
